import React, { useCallback, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Navbar, SideBar } from "./Layouts/MainPage";
import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import Dashboard from "./Components/Icons/Dasboard";
import Task from "./Components/Icons/Task";
import Maintanance from "./Components/Icons/Maintanance";
import Products from "./Components/Icons/Products";
import Marketing from "./Components/Icons/Marketing";
import Procurement from "./Components/Icons/Procurement";
import Team from "./Components/Icons/Team";
import Report from "./Components/Icons/Report";
import Chat from "./Components/Icons/Chat";
import Payments from "./Components/Icons/Payments";
import Sales from "./Components/Icons/Sales";
import Store from "./Components/Icons/Store";
import Shipping from "./Components/Icons/Shipping";
import { GetAccess, GetDashboardRole, GetMultipleAccess, GetRole } from "./Components/Utils/roles";
import DashboardSide from "./Components/Icons/DasboardSide";
import Invoice from "./Components/Icons/Invoice";
import Notes from "./Components/Icons/Notes";

const App = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();


    // handle what happens on key press
    const handleKeyPress = useCallback((event) => {
      if(event.key === "Escape") {
        navigate(-1);
      }
    }, []);
  
    useEffect(() => {
      // attach the event listener
      document.addEventListener('keydown', handleKeyPress);
  
      // remove the event listener
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }, [handleKeyPress]);


  function isActiveFun(x){
    let actualPath = location.pathname.split("/")[1]
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         let z = y.split("/")[0]
         linkPath = z
      }
    }else{
      linkPath = x?.link;
    }
    if(actualPath == linkPath) {
      return true;
    }else{
      return false;
    }
  }


  const navItem = [
    {
      icon: <DashboardSide/>,
      title: "Dashboard",
      hasSubMenu: false,
      hasAccess:true,
      link: GetDashboardRole("")?"dashboard":GetDashboardRole("sales")?"/dashboard/sales":GetDashboardRole("procurement")?"/dashboard/procurement":GetDashboardRole("store")?"/dashboard/stores":"/dashboard",
    },
    // {
    //   icon: <Products/>,
    //   title: "Product",
    //   link: "products/items",
    //   hasSubMenu: false,
    //   hasAccess:["catalogue_view","items_view"]
    //   // subMenu: [
    //     // {
    //     //   name: "Catalogues",
    //     //   link: "products/catalogues",
    //     // },
    //   //   {
    //   //     name: "Items",
    //   //     link: "products/items",
    //   //   },
    //   // ],
    // },
    {
      icon: <Marketing/>,
      title: "Marketing",
      hasSubMenu: true,
      hasAccess:["appointments_view","leads_view"],
      subMenu: [
        {
          name: "Appointment",
          link: "marketing/appointments",
          hasAccess:'appointments_view'
        },
        {
          name: "Lead",
          link: "marketing/Leads",
          hasAccess:'leads_view'
        },
      ],
    },
    {
      icon: <Task/>,
      title: "Tasks",
      hasSubMenu: false,
      link: "tasks/my-task",
      subMenu: [false]
        // {
        //   name: "Services",
        //   link: "tasks/main-task-plan",
        // },
        // {
        //   name: "My Tasks",
        //   link: "tasks/my-tasks",

        // },
        // {
        //   name: "All Tasks",
        //   link: "tasks/all-tasks",

        // },
      // ],
    },
     {
      icon: <Notes/>,
      title: "My Diary",
      hasSubMenu: false,
      link: "/dairy",
      hasAccess: ["my_diary_module",]
    },
    // {
    //   link: GetAccess("my_diary_view")?`/main/${officeId}/mainNotes`:"#",
    //   icon: <Notes />  ,
    //   title: "My Diary",
    //   hasAccess: ["my_diary_module"],
    //   hasSubMenu: false,
    //   subMenu: [],
    // },
    {
      icon: <Procurement/>,
      title: "Procurement",
      hasAccess:["purchase_request_view","rfq_view","supplier_quote_view","quote_compare_view","purchase_order_view","suppliers_view","payment_request_view","team_performance_view"],
      hasSubMenu: true,
      subMenu: [

        {
          name: "Supplier",
          link: "procurement/suppliers",
          hasAccess:'suppliers_view'

        },
        {
          name: "Product",
          link: "procurement/items",
          hasAccess:'items_view'

        },
        {
          name: "Product Comparison",
          link: "procurement/product-comparison",
          hasAccess:'suppliers_view'

        },
        {
          name: "Purchase Request",
          link: "procurement/purchase-requests",
          hasAccess:'purchase_request_view'
        },
        {
          name: "RFQ",
          link: "procurement/rfq",
          hasAccess:'rfq_view'

        },
       
        {
          name: "Quote Comparison",
          link: "procurement/quote-comparison",
          hasAccess:'quote_compare_view'

        },
        {
          name: "Purchase Order",
          link: "procurement/purchase-order",
          hasAccess:'purchase_order_view'

        },
        
       
        {
          name: "Payment Request",
          link: "procurement/payment-request",
          hasAccess:'purchase_request_view'
        },
       
       
      ],
    },
    {
      icon: <Sales/>,
      title: "Sales",
      hasAccess:["customers_view","customer_quote_view","customer_order_view","sales_order_view","invoice_in_view","invoice_out_view","promotions_view"],
      hasSubMenu: true,
      subMenu: [
        {
          name: "Customer",
          link: "sales/customers",
          hasAccess:'customers_view'

        },
        {
          name: "Enquiries",
          link: "sales/enquiries",
          hasAccess:'customers_view'

        },
        {
          name: "Quote",
          link: "sales/quotes",
          hasAccess:'customer_quote_view'

        },
        
        {
          name: "Sales Order",
          link: "sales/sales-orders",
          hasAccess:'sales_order_view'

        },
       
      ],
    },
    {
      icon: <Invoice/>,
      title: "Invoice",
      hasAccess:["customers_view","customer_quote_view","customer_order_view","sales_order_view","invoice_in_view","invoice_out_view","promotions_view"],
      hasSubMenu: true,
      subMenu: [
          {
          name: "Invoices Incoming",
          link: "invoice/invoice_incoming",
          hasAccess:'invoice_in_view'

        },
        {
          name: "Invoices Outgoing",
          link: "invoice/invoice_outgoing",
          hasAccess:'invoice_out_view'

        },
      ]
    },
   
    {
      icon: <Store/>,
      title: "Store",
      hasAccess:["grn_view","inventory_view","assets_view","delivery_notes_view","packing_list_view","returns_view","requests_view"],
      hasSubMenu: true,
      subMenu: [
        {
          name: "GRN",
          link: "store/grn",
          hasAccess:'grn_view'

        },
        {
          name: "Inventory",
          link: "store/inventory",
          hasAccess:'inventory_view'

        },
             
        {
          name: "Delivery Note",
          link: "store/delivery-note",
          hasAccess:'delivery_notes_view'

        },
       
        {
          name: "Return",
          link: "store/returns",
          hasAccess:'returns_view'

        },
        
      ],
    },
    {
      icon: <Shipping/>,
      title: "Shipping",
      hasAccess:["agents_view","shipment_tracking_view"],
      hasSubMenu: true,
      subMenu: [
        {
          name: "Shipping Agent",
          link: "shipping/agents",
          hasAccess:'agents_view'

          
        },
        {
          name: "Shipment Tracking",
          link: "shipping/shipment-tracking",
          hasAccess:'shipment_tracking_view'

        },
      ],
    },
    
    {
      icon: <Report/>,
      title: "Report",
      hasAccess:["report_view"],
      hasSubMenu: false,
      link: "/reports",
      subMenu:[
        {
          name: "Procurement",
          link: "reports/procurement/cost-saving-analysis",
          hasAccess:'report_view'
        },
      ]
    },
  ];

  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <SideBar>
        {navItem && 
          navItem.map((item,idx) => {
            
            return (
              <>
              {
                (item?.hasAccess == true||GetMultipleAccess(item?.hasAccess||[]) )&&(<SidebarItem
                    icon={item?.icon}
                    text={t(item?.title)}
                    hasSubMenu={item?.hasSubMenu}
                    subItem={item?.subMenu}
                    link={item?.link}
                    active={isActiveFun(item)}
                    key={idx}
                  />
                )
              }
              </>
            );
          })}
      </SideBar>

      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
        {/* <div className=" w-full h-7 ">
          <p className=' font-semibold text-center text-s text-slate-400'>
            <a
             href="https://numota.in"
             target="_blank"
            >
              &#169;  numota
            </a>
            </p>
        </div> */}
      </div>
    </div>
  );
};

export default App;
